export const tr = {
  'language.az': 'Azərbaycanca',
  'language.en': 'English',
  'language.hu': 'Magyar',
  'language.pt': 'Português',
  'language.ru': 'Русский',
  'language.tr': 'Türkçe',
  'language.uz': 'Oʻzbek',

  'order': 'Sipariş {order}',
  'amount': '{amount}',

  'card.sample.expiry': 'son kullanma',
  'card.sample.name': 'ADINIZ SOYADINIZ',

  'card.pan': 'Kart numarası',
  'card.owner': 'Kart sahibinin adı',
  'card.expiry': 'Son kullanma',
  'card.cvc': 'CVC',
  'card.captcha_text': 'Resimdeki karakterleri girin',

  'card.btn.pay': 'Öde',

  'card.error.pan.required': 'Lütfen bu alanı doldurun.',
  'card.error.pan.invalid': 'Geçersiz kart numarası.',
  'card.error.pan.whitelist': 'Yalnızca şu kartlar kullanılabilir: {list}.',
  'card.error.name.invalid': 'Geçersiz karakterler.',
  'card.error.name.fullname': 'Ad ve soyadı girin.',
  'card.error.name.required': 'Lütfen bu alanı doldurun.',
  'card.error.cvc.required': 'Lütfen bu alanı doldurun.',
  'card.error.cvc.invalid': 'Lütfen bu alanı doldurun.',
  'card.error.expiry.required': 'Lütfen bu alanı doldurun.',
  'card.error.expiry.month.invalid': '01 ile 12 arasında bir değer girin.',
  'card.error.expiry.year.invalid': 'Geçerli veya gelecek yılları girin.',
  'card.error.captcha_text.required': 'Lütfen bu alanı doldurun.',

  'card.protected.caption.title': 'Verileriniz korunmaktadır',
  'card.protected.caption.desc': 'Banka kartı bilgileri güvenli protokoller kullanılarak iletilir; çevrimiçi mağazaya veya üçüncü şahıslara gönderilmez. Ödemeler, PCI DSS standartlarına uygun güvenli bir işlem sayfasında işlenir.',

  'card.sending.preloader.title': 'Lütfen pencereyi kapatmayın veya sayfayı yenilemeyin',
  'card.sending.preloader.desc': 'Bağlantı oluşturuluyor. Bu işlem birkaç saniyeden bir dakikaya kadar sürebilir.',

  'fatal_errors': 'Reddetme nedeni:',

  'card.processing.1': 'Veri hazırlama',
  'card.processing.2': 'Ödeme imkanı kontrol ediliyor',
  'card.processing.3': 'Ödeme işleniyor',

  'finish.pending': 'Teşekkürler! Ödemeniz işleniyor',
  'finish.pending.desc': ' ',
  'finish.new': 'Teşekkürler! Ödemeniz işleniyor',
  'finish.new.desc': ' ',
  'finish.complete': 'Ödeme başarıyla tamamlandı',
  'finish.complete.desc': ' ',
  'finish.failed': 'Ödeme reddedildi',
  'finish.failed.desc': ' ',
  'finish.refunded': 'Ödeme iade edildi',
  'finish.refunded.desc': ' ',
  'finish.exception': 'Bir şeyler ters gitti',
  'finish.exception.desc': ' ',

  'finish.debug_info': 'Destek Bilgileri',

  'return.btn.return': 'Mağazaya geri dön',

  'error.general': 'Bir şeyler ters gitti... lütfen tekrar deneyin.'
}
